const logoSpanClassNames = `
  col-span-6 sm:col-span-5
  text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl
  leading-6 sm:leading-7 md-leading-8 lg:leading-9 leading-10
  font-semibold text-main-blue
`

function Logo() {
  return (
    <div className="col-span-2 grid grid-cols-8 text-center">
      <span className={logoSpanClassNames}>
        進学センサス
        <br></br>
        DATABOOK
      </span>
    </div>
  );
}

export default Logo;
